'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _AccountResource = require('./AccountResource');

var _AccountResource2 = _interopRequireDefault(_AccountResource);

var _CampaignResource = require('./CampaignResource');

var _CampaignResource2 = _interopRequireDefault(_CampaignResource);

var _ComponentResource = require('./ComponentResource');

var _ComponentResource2 = _interopRequireDefault(_ComponentResource);

var _ContactResource = require('./ContactResource');

var _ContactResource2 = _interopRequireDefault(_ContactResource);

var _DashboardResource = require('./DashboardResource');

var _DashboardResource2 = _interopRequireDefault(_DashboardResource);

var _DataTypeResource = require('./DataTypeResource');

var _DataTypeResource2 = _interopRequireDefault(_DataTypeResource);

var _DateFieldResource = require('./DateFieldResource');

var _DateFieldResource2 = _interopRequireDefault(_DateFieldResource);

var _FieldMappingResource = require('./FieldMappingResource');

var _FieldMappingResource2 = _interopRequireDefault(_FieldMappingResource);

var _FieldReferenceResource = require('./FieldReferenceResource');

var _FieldReferenceResource2 = _interopRequireDefault(_FieldReferenceResource);

var _FieldResource = require('./FieldResource');

var _FieldResource2 = _interopRequireDefault(_FieldResource);

var _IntegrationResource = require('./IntegrationResource');

var _IntegrationResource2 = _interopRequireDefault(_IntegrationResource);

var _IntegrationRouteResource = require('./IntegrationRouteResource');

var _IntegrationRouteResource2 = _interopRequireDefault(_IntegrationRouteResource);

var _FormResource = require('./FormResource');

var _FormResource2 = _interopRequireDefault(_FormResource);

var _LeadResource = require('./LeadResource');

var _LeadResource2 = _interopRequireDefault(_LeadResource);

var _ScoringModelResource = require('./ScoringModelResource');

var _ScoringModelResource2 = _interopRequireDefault(_ScoringModelResource);

var _ModelAnalyticsResource = require('./ModelAnalyticsResource');

var _ModelAnalyticsResource2 = _interopRequireDefault(_ModelAnalyticsResource);

var _ProviderResource = require('./ProviderResource');

var _ProviderResource2 = _interopRequireDefault(_ProviderResource);

var _ProviderCampaignResource = require('./ProviderCampaignResource');

var _ProviderCampaignResource2 = _interopRequireDefault(_ProviderCampaignResource);

var _UserResource = require('./UserResource');

var _UserResource2 = _interopRequireDefault(_UserResource);

var _RequestResource = require('./RequestResource');

var _RequestResource2 = _interopRequireDefault(_RequestResource);

var _VizResource = require('./VizResource');

var _VizResource2 = _interopRequireDefault(_VizResource);

var _AgentResource = require('./AgentResource');

var _AgentResource2 = _interopRequireDefault(_AgentResource);

var _FilterResource = require('./FilterResource');

var _FilterResource2 = _interopRequireDefault(_FilterResource);

var _ThingTypeResource = require('./ThingTypeResource');

var _ThingTypeResource2 = _interopRequireDefault(_ThingTypeResource);

var _BasinResource = require('./BasinResource');

var _BasinResource2 = _interopRequireDefault(_BasinResource);

var _ScoringModelRuleResource = require('./ScoringModelRuleResource');

var _ScoringModelRuleResource2 = _interopRequireDefault(_ScoringModelRuleResource);

var _TagResource = require('./TagResource');

var _TagResource2 = _interopRequireDefault(_TagResource);

var _TimezonesResource = require('./TimezonesResource');

var _TimezonesResource2 = _interopRequireDefault(_TimezonesResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = function API($http) {
  (0, _classCallCheck3.default)(this, API);

  this.accounts = new _AccountResource2.default($http);
  this.campaigns = new _CampaignResource2.default($http);
  this.providerCampaigns = new _ProviderCampaignResource2.default($http);
  this.contacts = new _ContactResource2.default($http);
  this.dashboards = new _DashboardResource2.default($http);
  this.thingTypes = new _ThingTypeResource2.default($http);
  this.dataTypes = new _DataTypeResource2.default($http);
  this.components = new _ComponentResource2.default($http);
  this.fieldReferences = new _FieldReferenceResource2.default($http);
  this.fieldMappings = new _FieldMappingResource2.default($http);
  this.fields = new _FieldResource2.default($http);
  this.dateFields = new _DateFieldResource2.default($http);
  this.forms = new _FormResource2.default($http);
  this.leads = new _LeadResource2.default($http);
  this.scoringModels = new _ScoringModelResource2.default($http);
  this.modelanalytics = new _ModelAnalyticsResource2.default($http);
  this.user = new _UserResource2.default($http);
  this.viz = new _VizResource2.default($http);
  this.providers = new _ProviderResource2.default($http);
  this.integrations = new _IntegrationResource2.default($http);
  this.integrationRoutes = new _IntegrationRouteResource2.default($http);
  this.requests = new _RequestResource2.default($http);
  this.agents = new _AgentResource2.default($http);
  this.filters = new _FilterResource2.default($http);
  this.basin = new _BasinResource2.default($http);
  this.scoringModelRules = new _ScoringModelRuleResource2.default($http);
  this.tags = new _TagResource2.default($http);
  this.timezones = new _TimezonesResource2.default($http);
};

exports.default = API;


//////////////////
// WEBPACK FOOTER
// ./src/api/index.js
// module id = 329
// module chunks = 0